/**
 * @flow
 * @relayHash 03b3bab2a4a9ad21fa916bd390acdfea
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SolicitationCommentThread_solicitation$ref = any;
export type SolicitationCommentThreadRefetchQueryVariables = {|
  id: string
|};
export type SolicitationCommentThreadRefetchQueryResponse = {|
  +solicitation: ?{|
    +$fragmentRefs: SolicitationCommentThread_solicitation$ref
  |}
|};
export type SolicitationCommentThreadRefetchQuery = {|
  variables: SolicitationCommentThreadRefetchQueryVariables,
  response: SolicitationCommentThreadRefetchQueryResponse,
|};
*/

/*
query SolicitationCommentThreadRefetchQuery(
  $id: ID!
) {
  solicitation: solicitation(id: $id) {
    ...SolicitationCommentThread_solicitation_1Bmzm5
    id
  }
}

fragment SolicitationCommentThread_solicitation_1Bmzm5 on SolicitationNode {
  solicitationId
  state
  comments {
    edges {
      node {
        id
        content
        created
        contentEditedAt
        repliedTo {
          content
          created
          user {
            fullName
            id
          }
        }
        contractor {
          fullName
          representativeImageUrl
          freelancer {
            user {
              id
            }
            id
          }
          id
        }
        createdByStaff {
          fullName
          representativeImageUrl
          user {
            id
          }
          id
        }
      }
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'id',
        type: 'ID!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'Variable',
        name: 'id',
        variableName: 'id'
      }
    ],
    v2 = {
      kind: 'ScalarField',
      alias: null,
      name: 'id',
      args: null,
      storageKey: null
    },
    v3 = {
      kind: 'ScalarField',
      alias: null,
      name: 'content',
      args: null,
      storageKey: null
    },
    v4 = {
      kind: 'ScalarField',
      alias: null,
      name: 'created',
      args: null,
      storageKey: null
    },
    v5 = {
      kind: 'ScalarField',
      alias: null,
      name: 'fullName',
      args: null,
      storageKey: null
    },
    v6 = {
      kind: 'ScalarField',
      alias: null,
      name: 'representativeImageUrl',
      args: null,
      storageKey: null
    },
    v7 = {
      kind: 'LinkedField',
      alias: null,
      name: 'user',
      storageKey: null,
      args: null,
      concreteType: 'UserNode',
      plural: false,
      selections: [(v2 /*: any*/)]
    };
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'SolicitationCommentThreadRefetchQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: [
        {
          kind: 'LinkedField',
          alias: 'solicitation',
          name: 'solicitation',
          storageKey: null,
          args: (v1 /*: any*/),
          concreteType: 'SolicitationNode',
          plural: false,
          selections: [
            {
              kind: 'FragmentSpread',
              name: 'SolicitationCommentThread_solicitation',
              args: (v1 /*: any*/)
            }
          ]
        }
      ]
    },
    operation: {
      kind: 'Operation',
      name: 'SolicitationCommentThreadRefetchQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: [
        {
          kind: 'LinkedField',
          alias: 'solicitation',
          name: 'solicitation',
          storageKey: null,
          args: (v1 /*: any*/),
          concreteType: 'SolicitationNode',
          plural: false,
          selections: [
            {
              kind: 'ScalarField',
              alias: null,
              name: 'solicitationId',
              args: null,
              storageKey: null
            },
            {
              kind: 'ScalarField',
              alias: null,
              name: 'state',
              args: null,
              storageKey: null
            },
            {
              kind: 'LinkedField',
              alias: null,
              name: 'comments',
              storageKey: null,
              args: null,
              concreteType: 'SolicitationContractorLogNodeConnection',
              plural: false,
              selections: [
                {
                  kind: 'LinkedField',
                  alias: null,
                  name: 'edges',
                  storageKey: null,
                  args: null,
                  concreteType: 'SolicitationContractorLogNodeEdge',
                  plural: true,
                  selections: [
                    {
                      kind: 'LinkedField',
                      alias: null,
                      name: 'node',
                      storageKey: null,
                      args: null,
                      concreteType: 'SolicitationContractorLogNode',
                      plural: false,
                      selections: [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        {
                          kind: 'ScalarField',
                          alias: null,
                          name: 'contentEditedAt',
                          args: null,
                          storageKey: null
                        },
                        {
                          kind: 'LinkedField',
                          alias: null,
                          name: 'repliedTo',
                          storageKey: null,
                          args: null,
                          concreteType: 'CommentRepliedToNode',
                          plural: false,
                          selections: [
                            (v3 /*: any*/),
                            (v4 /*: any*/),
                            {
                              kind: 'LinkedField',
                              alias: null,
                              name: 'user',
                              storageKey: null,
                              args: null,
                              concreteType: 'UserNode',
                              plural: false,
                              selections: [(v5 /*: any*/), (v2 /*: any*/)]
                            }
                          ]
                        },
                        {
                          kind: 'LinkedField',
                          alias: null,
                          name: 'contractor',
                          storageKey: null,
                          args: null,
                          concreteType: 'ContractorNode',
                          plural: false,
                          selections: [
                            (v5 /*: any*/),
                            (v6 /*: any*/),
                            {
                              kind: 'LinkedField',
                              alias: null,
                              name: 'freelancer',
                              storageKey: null,
                              args: null,
                              concreteType: 'FreelancerNode',
                              plural: false,
                              selections: [(v7 /*: any*/), (v2 /*: any*/)]
                            },
                            (v2 /*: any*/)
                          ]
                        },
                        {
                          kind: 'LinkedField',
                          alias: null,
                          name: 'createdByStaff',
                          storageKey: null,
                          args: null,
                          concreteType: 'StaffNode',
                          plural: false,
                          selections: [
                            (v5 /*: any*/),
                            (v6 /*: any*/),
                            (v7 /*: any*/),
                            (v2 /*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            (v2 /*: any*/)
          ]
        }
      ]
    },
    params: {
      operationKind: 'query',
      name: 'SolicitationCommentThreadRefetchQuery',
      id: null,
      text:
        'query SolicitationCommentThreadRefetchQuery(\n  $id: ID!\n) {\n  solicitation: solicitation(id: $id) {\n    ...SolicitationCommentThread_solicitation_1Bmzm5\n    id\n  }\n}\n\nfragment SolicitationCommentThread_solicitation_1Bmzm5 on SolicitationNode {\n  solicitationId\n  state\n  comments {\n    edges {\n      node {\n        id\n        content\n        created\n        contentEditedAt\n        repliedTo {\n          content\n          created\n          user {\n            fullName\n            id\n          }\n        }\n        contractor {\n          fullName\n          representativeImageUrl\n          freelancer {\n            user {\n              id\n            }\n            id\n          }\n          id\n        }\n        createdByStaff {\n          fullName\n          representativeImageUrl\n          user {\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '6823d81647b2486d8f393321e6ed7d75';
module.exports = node;
